function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 267 267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.55556,0,0,5.55556,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,0.5C14.91,0.5 7.55,7.86 7.55,16.95C7.55,29.29 24,47.5 24,47.5C24,47.5 40.45,29.29 40.45,16.95C40.45,7.86 33.09,0.5 24,0.5Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.99,7C16.08,7.03 16.18,7.05 16.27,7.07C16.57,7.14 16.82,7.28 17.03,7.49C19.15,9.61 21.28,11.73 23.4,13.85C23.43,13.88 23.46,13.92 23.5,13.96C22.39,15.21 21.21,16.39 19.96,17.51C19.91,17.46 19.86,17.42 19.81,17.38C17.71,15.29 15.62,13.19 13.52,11.1C13.26,10.84 13.1,10.52 13.01,10.17L13.01,9.7C13.1,9.21 13.41,8.85 13.77,8.52C14.01,8.3 14.25,8.07 14.46,7.83C14.85,7.4 15.28,7.07 15.88,7L16,7L15.99,7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.91,7C31.2,7.07 31.48,7.12 31.76,7.2C32.22,7.33 32.66,7.52 33.04,7.83C33.32,8.06 33.31,8.19 32.97,8.33C31.99,8.74 31.01,9.14 30.04,9.55C29.63,9.72 29.51,9.94 29.61,10.36C29.81,11.21 30.15,12.01 30.61,12.75C30.81,13.07 31.07,13.15 31.41,13C32.39,12.6 33.37,12.19 34.35,11.79C34.47,11.74 34.61,11.75 34.74,11.73C34.76,11.87 34.8,12.01 34.79,12.14C34.55,13.84 32.95,15.42 31.24,15.59C29.36,15.78 28.01,14.92 27.08,13.35C26.37,12.15 26.17,10.85 26.7,9.53C27.26,8.11 28.39,7.37 29.85,7.07C29.97,7.05 30.09,7.02 30.21,6.99L30.92,6.99L30.91,7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.88,7C15.29,7.07 14.85,7.4 14.46,7.83C14.24,8.07 14.01,8.3 13.77,8.52C13.41,8.85 13.11,9.21 13.01,9.7L13.01,6.99L15.87,6.99L15.88,7Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.09,23.4C21.47,21.65 20.38,20.39 18.61,19.74C21.35,17.68 23.74,15.3 25.79,12.55C26.39,14.3 27.47,15.57 29.22,16.24C26.5,18.29 24.14,20.66 22.1,23.4L22.09,23.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.46,24.54C21.55,26.58 20.53,28.08 18.89,28.7C17.6,29.19 16.35,29.07 15.16,28.39C15.01,28.31 14.88,28.2 14.76,28.08C14.61,27.94 14.64,27.84 14.81,27.74C14.88,27.7 14.95,27.67 15.02,27.64C15.97,27.25 16.91,26.86 17.86,26.46C18.27,26.29 18.38,26.08 18.28,25.64C18.08,24.78 17.74,23.98 17.27,23.23C17.08,22.93 16.83,22.85 16.5,22.99C15.53,23.39 14.57,23.79 13.6,24.18C13.46,24.24 13.3,24.24 13.16,24.26C13.14,24.1 13.09,23.94 13.12,23.79C13.48,22.18 14.43,21.07 16,20.55C17.5,20.06 18.83,20.46 19.96,21.52C20.93,22.43 21.42,23.57 21.48,24.52L21.46,24.54Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.68,20.55C25.98,20.25 26.25,19.97 26.57,19.65C26.62,19.73 26.65,19.8 26.71,19.86C28.59,21.74 30.46,23.62 32.35,25.49C32.49,25.63 32.67,25.75 32.85,25.81C33.33,25.97 33.7,26.23 33.97,26.67C34.25,27.12 34.57,27.54 34.87,27.98C35.04,28.23 35.02,28.33 34.81,28.54C34.68,28.67 34.55,28.8 34.42,28.93C34.32,29.03 34.21,29.05 34.09,28.97C33.46,28.53 32.82,28.1 32.2,27.63C32.05,27.52 31.96,27.3 31.91,27.11C31.79,26.71 31.56,26.41 31.27,26.12C29.45,24.32 27.65,22.51 25.84,20.7C25.79,20.65 25.74,20.61 25.68,20.56L25.68,20.55Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskMarker);
export default __webpack_public_path__ + "static/media/TaskMarker.3465306c09fedc777eb98360689a6eb3.svg";
export { ForwardRef as ReactComponent };